import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { getContactBulkActions, getContactBulkAction, updateContactBulkAction } from '../../services/contactBulkActions';

import { CircularProgress } from '@material-ui/core';
import { PencilSingleIcon } from '@stash-ui/regular-icons';
import UpdateContactBulkActionModal from './components/UpdateContactBulkActionModal';

const ContactBulkActions = ({ location, match }) => {
  const dispatch = useDispatch();

  const [isUpdateContactBulkActionModalOpen, setIsUpdateContactBulkActionModalOpen] = useState(false);
  const [isUpdatingContactBulkAction, setIsUpdatingContactBulkAction] = useState(false);
  const [contactBulkActionFormData, setContactBulkActionFormData] = useState({});

  const [contactBulkActions, setContactBulkActions] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayContactBulkActions(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'status', 'createdAt', 'deletedAt'];
  const SearchBoxHeaders = ['id', 'status'];

  const displayContactBulkActions = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: contactBulkActionsData } = await getContactBulkActions(currentPage || page, params);

      setContactBulkActions(contactBulkActionsData.rows);
      setTotalItems(contactBulkActionsData.count);
      setTotalPages(contactBulkActionsData.pages);
      setPage(contactBulkActionsData.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const handleSubmitContactBulkActionFormData = async data => {
    try {
      if (isUpdatingContactBulkAction) {
        await updateContactBulkAction(data.id, data);
      }

      dispatch(showAlert('success', 'Success! 🔥'));
      window.location.reload();
    } catch (error) {
      dispatch(showAlert('error', 'Error! Something went wrong. 😔'));
    }
  };

  const customActions = [
    {
      icon: <PencilSingleIcon />,
      action: item => {
        handleOpenUpdate(item);
      },
    },
  ];

  const handleOpenUpdate = async item => {
    const { data } = await getContactBulkAction(item.id);
    setIsUpdatingContactBulkAction(true);

    setContactBulkActionFormData(data.rows[0]);
    setIsUpdateContactBulkActionModalOpen(true);
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="users-container">
        <h1>Contact Bulk Actions ({totalItems})</h1>

        <div className="users-right">
          <SearchBox
            date-testid="search-box"
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        </div>
      </div>

      <DataTable
        head={headers}
        body={contactBulkActions}
        action={false}
        customActions={customActions}
        bodyColumn={headers}
        linkPath="contact-bulk-actions"
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
      />

      <UpdateContactBulkActionModal
        isOpen={isUpdateContactBulkActionModalOpen}
        onClose={() => setIsUpdateContactBulkActionModalOpen(false)}
        dataForm={contactBulkActionFormData}
        isUpdating={isUpdatingContactBulkAction}
        onSubmit={handleSubmitContactBulkActionFormData}
      />
    </>
  );
};

export default ContactBulkActions;
